export default class ActivityItemService {
    static fromJSON(activityItem) {
        // @ts-expect-error - TS2740 - Type '{ createdDate: Date; updatedDate: Date; }' is missing the following properties from type 'ActivityItem': itemIdInt, itemIdUUID, locationIds, activityItemType, and 14 more.
        return Object.assign(Object.assign({}, activityItem), { createdDate: new Date(activityItem.createdDate), updatedDate: new Date(activityItem.updatedDate) });
    }
    static isAboutSameItem(a, b) {
        return (a.activityItemType.id === b.activityItemType.id &&
            a.itemIdInt === b.itemIdInt &&
            a.itemIdUUID === b.itemIdUUID);
    }
}
